'use strict';

var FirebaseObject = require('./FirebaseObject');
var KayleeBase = require('./KayleeBase');
var KayleeCache = require('./KayleeCache');
var KayleeLogMessages = require('./KayleeLogMessages');
var log = require('../log/Log').channel('KayleeLog');

var KayleeLog = {
    fromJson: fromJson,
    getLog: getLog,
};

function fromJson(data) {
    var reqProps = [ '$id' ];
    return FirebaseObject.$fromJson(data, 'Log', reqProps, reqProps,
        function(data) { return getLog(data.$id); }
    );
}

// Returns a promise that resolves to the Log object when it is loaded.

function getLog(logId) {
    var key = 'Log: ' + logId;
    var log = KayleeCache.get(key);

    if (log === null) {
        log = new Log(logId);
        KayleeCache.put(key, log);
    }

    return log;
}

function Log(logId) {
    this.$nodeType = 'log';
    FirebaseObject.call(this,
        KayleeBase.app.database().ref('logs/headers/' + logId));
}

Log.prototype = Object.create(FirebaseObject.prototype);
Log.prototype.constructor = Log;

Log.prototype.$toJson = function() {
    return FirebaseObject.prototype.$toJson.call(this, [ '$id' ]);
};

Log.prototype.toString = function() {
    if (this.$internalIsLoaded) {
        if (this.appName === 'Inara') {
            return '[Log for [Controller (' + this.controllerId + ')] at ' +
                this.time + ' (' + this.$id +')]';

        } else if (this.appName === 'Mal') {
            return '[Log for [User (' + this.userId + ')] at ' + this.time +
                ' (' + this.$id + ')]';
        }
    }

    return '[Log (' + this.$id + ')]';
};

Log.prototype.$addUpdatesToRemoveLog = function(update) {
    update['logs/headers/' + this.$id] = null;
    update['logs/messages/' + this.$id] = null;
    update['index/logsByController/' + this.controllerId + '/' + this.$id] = null;
    return Promise.resolve(update);
};

Log.prototype.$remove = function() {
    if (!this.$internalIsLoaded) {
        var err = new Error(this + ' not loaded');
        log.error(err.message);
        return Promise.reject(err);
    }

    var self = this;

    return self.$addUpdatesToRemoveLog({})
    .then(function(update) {
        KayleeBase.update(update)
        .then(function() {
            log.info('removed ' + self);
        }, function(err) {
            log.error('failed removing ' + self + ', error: ' + err);
        });
    });
};

Log.prototype.$getMessages = function() {
    return KayleeLogMessages.getLogMessages(this.$id);
};

module.exports = KayleeLog;
